import { Button } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import Breadcrumbs from '@/components/Breadcrumbs';
import Page from '@/components/Page';
import PageContent from '@/components/PageContent';
import PageHeader from '@/components/PageHeader';
import PageTitle from '@/components/PageTitle';
import PageTitleLink from '@/components/PageTitleLink';
import CanView from '@/containers/CanView';
import { isMallStaff } from '@/features/currentUser/selectors';
import { downloadXls } from '@/features/mallBonusesPage/utils';
import { ROUTE_PATH as STORE_BONUSES_PATH } from '@/features/storeBonusesPage/consts';

import { SelectBonusType } from '../../../components/SelectBonusType/SelectBonusType';
import Table from './Table';

class MallBonuses extends Component {
  static propTypes = {
    error: PropTypes.any,
    mallBonusIds: PropTypes.arrayOf(PropTypes.any).isRequired,
    isLoading: PropTypes.bool.isRequired,
    totalCount: PropTypes.number.isRequired,
  };

  static defaultProps = {
    error: null,
  };

  constructor(props) {
    super(props);

    this.state = { dialog: false };
  }

  render() {
    const { error, mallBonusIds, isLoading, totalCount, classes } = this.props;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { dialog } = this.state;

    return (
      <Page>
        <PageHeader borderBottom gutterBottom={false}>
          <Breadcrumbs />
          <Grid container alignItems="baseline">
            <PageTitle gutterBottom={false}>Esentai Mall</PageTitle>
            <PageTitleLink to={STORE_BONUSES_PATH}>Магазин</PageTitleLink>
          </Grid>
        </PageHeader>
        <PageContent>
          <div className={classes.wrapper}>
            <Button
              variant="contained"
              color="primary"
              className={classes.excelButton}
              onClick={downloadXls}
            >
              Вывести в Excel
            </Button>
            <CanView permission={isMallStaff}>
              <Button
                variant="contained"
                color="primary"
                className={classes.excelButton}
                onClick={() => {
                  this.setState({ dialog: true });
                }}
              >
                Создать настройку бонусов
              </Button>
            </CanView>
            <Table
              error={error}
              items={mallBonusIds}
              isLoading={isLoading}
              totalCount={totalCount}
            />
          </div>
          <SelectBonusType
            open={dialog}
            onClose={() => this.setState({ dialog: false })}
          />
        </PageContent>
      </Page>
    );
  }
}

export default MallBonuses;
